import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Badge, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { Favicon } from "app/pages/digital-marketing/monitor-and-protect/shared/ui/layout/favicon";
import { TruncateTextWithTooltip } from "app/pages/digital-marketing/monitor-and-protect/shared/ui/typography/texts";
import { useTranslation } from "pro-features/components/WithTranslation";
import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

interface ICampaignHeaderProps {
    domain: string;
    campaignName: string;
    sharedBy?: string;
    isOwner?: boolean;
    type?: "Demo" | "Normal";
}

export const CampaignHeader = ({ domain, campaignName, sharedBy, isOwner, type }: ICampaignHeaderProps) => {
    const translate = useTranslation();

    const renderOwnershipIcon = () => {
        if (type !== "Normal") {
            return null;
        }

        if (isOwner) {
            return (
                <Tooltip
                    content={translate("monitor_and_protect.shared.campaign_header.my_campaign")}
                    placement="top"
                >
                    <div
                        role="tooltip"
                        aria-label={translate("monitor_and_protect.shared.campaign_header.my_campaign")}
                    >
                        <SWReactIcons
                            iconName="user"
                            size="xs"
                            iconColor={colorsPalettes.carbon["200"]}
                        />
                    </div>
                </Tooltip>
            );
        }

        if (sharedBy) {
            return (
                <Tooltip
                    content={translate("monitor_and_protect.shared.campaign_header.shared_by", { sharedBy })}
                    placement="top"
                >
                    <div
                        role="tooltip"
                        aria-label={translate("monitor_and_protect.shared.campaign_header.shared_by", { sharedBy })}
                    >
                        <SWReactIcons
                            iconName="users"
                            size="xs"
                            iconColor={colorsPalettes.carbon["200"]}
                        />
                    </div>
                </Tooltip>
            );
        }

        return null;
    };

    return (
        <Flex
            alignItems="center"
            gap="8px"
        >
            <Favicon
                size={32}
                iconUrl={getFaviconUrl(domain, 32)}
                alt={domain}
            />
            <Flex
                gap="8px"
                alignItems="baseline"
            >
                <TruncateTextWithTooltip
                    fontVariant="subtitle1"
                    color={colorsPalettes.carbon["500"]}
                    lineClamp={1}
                    maxWidth="200px"
                >
                    {campaignName}
                </TruncateTextWithTooltip>
                <TruncateTextWithTooltip
                    fontVariant="tooltip"
                    lineClamp={1}
                    maxWidth="200px"
                    color={colorsPalettes.carbon["400"]}
                >
                    {domain}
                </TruncateTextWithTooltip>
            </Flex>
            {renderOwnershipIcon()}
            {type === "Demo" ? <Badge type="demo">{translate("monitor_and_protect.shared.badges.demo")}</Badge> : null}
        </Flex>
    );
};
